import React, { useState, useContext, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import ConfirmModal from "../library/ConfirmModal";
import axios from "axios";
import API_BASE_URL from "../../config/api";


import {
  FiMenu,
  FiChevronLeft,
  FiChevronRight,
  FiBarChart2,
  FiList,
  FiFileText,
  FiPieChart,
  FiSettings,
  FiLogOut,
  FiCalendar,
  FiBriefcase,
  FiMessageSquare,
  FiClock,
  FiDollarSign,
  FiDatabase,
  FiUserCheck,
  FiClipboard,
  FiCreditCard,
} from "react-icons/fi";

export default function NavbarLayout({ children }) {
  const { token } = useContext(AuthContext);
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const [employee, setEmployee] = useState(null);

  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const employeeId = sessionStorage.getItem("employeeId");

  const userRole = sessionStorage.getItem("userrole");

  const navItems = [
    {
      icon: <FiBarChart2 />,
      label: "Dashboard",
      path: "/app/dashboard",
      roles: ["1", "2", "3"],
    },
    {
      icon: <FiList />,
      label: "Employees",
      path: "/app/employees",
      roles: ["1"],
    },
    {
      icon: <FiFileText />,
      label: "Self Service",
      path: "/app/selfservice",
      roles: ["1", "2", "3"],
    },
    {
      icon: <FiPieChart />,
      label: "Profile",
      path: "/app/profile",
      roles: ["1", "2", "3"],
    },
    // {
    //   icon: <FiSettings />,
    //   label: "Settings",
    //   path: "/app/settings",
    //   roles: ["Admin"],
    // },
    {
      icon: <FiClock />,
      label: "Leave Request",
      path: "/app/leavedashboard",
      roles: ["1", "2", "3"],
    },
    {
      icon: <FiDollarSign />,
      label: "Payroll",
      path: "/app/payroll",
      roles: ["1"],
    },
    {
      icon: <FiCalendar />,
      label: "Calendar",
      path: "/app/calendar",
      roles: ["1", "2", "3"],
    },
    {
      icon: <FiBriefcase />,
      label: "Comapny Details",
      path: "/app/companydetails",
      roles: ["1", "2", "3"],
    },
    {
      icon: <FiMessageSquare />,
      label: "Company Events News",
      path: "/app/companyeventsnews",
      roles: ["1"],
    },
    {
      icon: <FiDatabase />,
      label: "Master Screen",
      path: "/app/masterscreen",
      roles: ["1"],
    },
    {
      icon: <FiCreditCard />,
      label: "Advance Payment Request",
      path: "/app/advancepaymentrequestlist",
      roles: ["1", "2", "3"],
    },
    {
      icon: <FiUserCheck />,
      label: "Clients List",
      path: "/app/clientslist",
      roles: ["1"],
    },
    // {
    //   icon: <FiLogOut />,
    //   label: "Logout",
    //   type: "logout",
    //   roles: ["1", "2", "3"],
    // },
  ];

  const filteredNavItems = navItems.filter((item) =>
    item.roles.includes(userRole)
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".relative")) setShowProfileMenu(false);
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);


  useEffect(() => {
    if (!employeeId) return;

    const fetchEmployee = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/employee/profile/${employeeId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setEmployee(res.data);
      } catch (err) {
        console.error("Failed to load profile:", err);
      }
    };

    fetchEmployee();
  }, [employeeId, token]);

  return (
    <div className="flex min-h-screen font-sans text-gray-800 overflow-x-hidden">
      {/* Mobile Overlay */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-40 z-30 lg:hidden transition-opacity ${mobileOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
          }`}
        onClick={() => setMobileOpen(false)}
      />

      {/* Side Nav */}
      <aside
        className={`fixed lg:static z-40 bg-white border-r border-gray-200 flex flex-col transition-all duration-300 ease-in-out min-h-screen
          ${collapsed ? "w-16" : "w-64"} 
          ${mobileOpen ? "translate-x-0" : "-translate-x-full"
          } lg:translate-x-0`}
      >
        {/* App Icon & Brand */}
        <div className="flex items-center gap-3 p-4 ">
          <svg
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-10 text-blue-600"
          >
            <path
              d="M8.57829 8.57829C5.52816 11.6284 3.451 15.5145 2.60947 19.7452C1.76794 23.9758 2.19984 28.361 3.85056 32.3462C5.50128 36.3314 8.29667 39.7376 11.8832 42.134C15.4698 44.5305 19.6865 45.8096 24 45.8096C28.3135 45.8096 32.5302 44.5305 36.1168 42.134C39.7033 39.7375 42.4987 36.3314 44.1494 32.3462C45.8002 28.361 46.2321 23.9758 45.3905 19.7452C44.549 15.5145 42.4718 11.6284 39.4217 8.57829L24 24L8.57829 8.57829Z"
              fill="currentColor"
            />
          </svg>
          {!collapsed && (
            <span className="text-lg font-bold text-gray-900">TheBase</span>
          )}
        </div>

        {/* Collapse/Expand Toggle */}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="hidden lg:flex p-4 text-gray-600 hover:text-black focus:outline-none"
        >
          {collapsed ? <FiChevronRight /> : <FiChevronLeft />}
        </button>

        {/* Mobile Close Toggle */}
        <button
          onClick={() => setMobileOpen(false)}
          className="flex lg:hidden p-4 text-gray-600 hover:text-black focus:outline-none"
        >
          ✖️ Close
        </button>

        {/* Nav Items */}
        <nav className="flex-1 p-4 space-y-2">
          {filteredNavItems.map((item, index) =>
            item.type === "logout" ? (
              <button
                key={index}
                onClick={() => {
                  handleLogout();
                  setMobileOpen(false);
                }}
                className="flex items-center gap-3 px-3 py-2 rounded hover:bg-gray-100 w-full text-left"
              >
                <span className="text-lg">{item.icon}</span>
                {!collapsed && <span className="text-sm">{item.label}</span>}
              </button>
            ) : (
              <NavLink
                key={index}
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2 rounded hover:bg-gray-100 ${isActive ? "bg-gray-100 font-semibold" : ""
                  }`
                }
                onClick={() => setMobileOpen(false)}
              >
                <span className="text-lg">{item.icon}</span>
                {!collapsed && <span className="text-sm">{item.label}</span>}
              </NavLink>
            )
          )}
        </nav>
      </aside>

      {/* Content Area */}
      <div className="flex flex-col flex-1">
        {/* Top Nav */}
        <header className="flex items-center justify-between border-b border-gray-200 px-4 lg:px-8 py-4">
          <div className="flex items-center gap-4">
            {/* Hamburger Toggle (Mobile) */}
            <button
              className="text-gray-800 lg:hidden"
              onClick={() => setMobileOpen(true)}
            >
              <FiMenu size={24} />
            </button>
          </div>
          <nav className="hidden md:flex items-center gap-8">
            {/* "Dashboard", "Leave", "Attendance", "Expenses", "People", */}
            {["Settings"].map((link) => (
              <a
                key={link}
                href="#"
                className="text-sm font-medium hover:underline"
              >
                {link}
              </a>
            ))}
            {/* <div
              className="w-10 h-10 rounded-full bg-cover bg-center"
              style={{
                backgroundImage: `url('${
                  employee?.avatar
                    ? `${API_BASE_URL}/uploads/${employee.avatar}`
                    : "https://lh3.googleusercontent.com/aida-public/AB6AXuAjMXDBQbIsfYx2cdBcHr6wNFkSdzqCKYZ2WgSIf5uM5v2WeUswYbq6VUty7208NvWnD8w5xqvvHdvborKoz-9yZUIFQ91ZCCW7Z0wIcHAuvAxV-Yu6HW7W6AQEb90YOOhyc0FmiJK_MYc6ImowegoMbeZarKspZxjzdmtHFnarWksf_RW8bPGXZsAOvJ24aNhnNkT1MKE0uskGbVpDBq-o3CY645wPCa1o5NiDgyVj6YMjKlSp1KaGB4A64OtniBf6BNtUBT1q-7YB"
                }')`,
              }}              
            ></div> */}
            <div className="relative">
              <div
                className="w-10 h-10 rounded-full bg-cover bg-center cursor-pointer border border-gray-200"
                style={{
                  backgroundImage: `url('${employee?.avatar
                      ? `${API_BASE_URL}/uploads/${employee.avatar}`
                      : "https://lh3.googleusercontent.com/aida-public/AB6AXuAjMXDBQbIsfYx2cdBcHr6wNFkSdzqCKYZ2WgSIf5uM5v2WeUswYbq6VUty7208NvWnD8w5xqvvHdvborKoz-9yZUIFQ91ZCCW7Z0wIcHAuvAxV-Yu6HW7W6AQEb90YOOhyc0FmiJK_MYc6ImowegoMbeZarKspZxjzdmtHFnarWksf_RW8bPGXZsAOvJ24aNhnNkT1MKE0uskGbVpDBq-o3CY645wPCa1o5NiDgyVj6YMjKlSp1KaGB4A64OtniBf6BNtUBT1q-7YB"
                    }')`,
                }}
                onClick={() => setShowProfileMenu((prev) => !prev)}
              ></div>

              {/* Dropdown Menu */}
              {showProfileMenu && (
                <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
               
                  <button
                    onClick={() => {
                      setShowProfileMenu(false);
                      handleLogout();
                    }}
                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center gap-2"
                  >
                    <FiLogOut className="text-gray-600" />
                    Logout
                  </button>
                </div>
              )}
            </div>
          </nav>
        </header>

        <main className="flex-1 p-4 lg:p-8">{children}</main>
      </div>
      <ConfirmModal
        isOpen={showLogoutConfirm}
        title="Confirm Logout"
        message="Are you sure you want to log out?"
        confirmText="Logout"
        cancelText="Cancel"
        onCancel={() => setShowLogoutConfirm(false)}
        onConfirm={() => {
          sessionStorage.clear();
          logout();
          navigate("/");
          setShowLogoutConfirm(false);
        }}
      />
    </div>
  );
}
